import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { IntlShape } from "react-intl";
import { SearchRequestType } from "../../Orchestrator/Types/Index";
import { _eventBus } from "../../core/events/EventBus";
import { evtTree } from "../../Orchestrator/ConstantTree";
import { TrainTypeEnum } from "../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IPassBooking } from "../../Orchestrator/Types/Types/BookingTypes";

// dayjs.tz() below requires these plugins. They are extended per-module across
// this codebase (no global setup), so extend here too rather than rely on some
// other module having loaded first.
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Formats a calendar day into the departureTime string the booking flow expects.
 * Today resolves to the current Dubai time; any other day starts at midnight.
 */
export function toDepartureTime(date: Dayjs): string {
  return date.isSame(dayjs(), "day")
    ? dayjs().tz("Asia/Dubai").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
    : date.format("YYYY-MM-DDT00:00:00.000");
}

interface GoToTrainOffersParams {
  origin: string;
  destination: string;
  date: Dayjs;
  intl: IntlShape;
  passOffer?: IPassBooking;
}

/**
 * Builds the outbound search request and emits the Book Now event that takes the
 * user to the train-offers list for the given origin/destination/day.
 *
 * Shared by the date-picker "Continue" button (SelectDateModal) and the Popular
 * Trip card's direct click, so both paths produce an identical search.
 */
export function goToTrainOffers({
  origin,
  destination,
  date,
  intl,
  passOffer,
}: GoToTrainOffersParams): void {
  const searchState: SearchRequestType = {
    origin,
    destination,
    departureTime: toDepartureTime(date),
    arrivalTime: undefined,
    passengerCounts: {
      adults: 1,
    },
    totalPassengerCount: 1,
    trainType: TrainTypeEnum.outbound,
    resetValue: true,
    fromfmlmSearch: false,
    tofmlmSearch: false,
    lastSearchClick: true,
    intl: intl,
  };

  _eventBus.emit({
    eventName: evtTree.DestinationDetail.BookNow.Click,
    data: { search: searchState, passBooking: passOffer },
  });
}
